import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, checkAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = m[1];

    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id });
        // Iter 93 — /auth/session returns the raw user doc without the
        // computed `totp_state`. Calling checkAuth() forces /auth/me so
        // ProtectedRoute can correctly route to TotpEnrolWizard / Verify
        // immediately — eliminates the "needs a refresh to see 2FA prompt"
        // bug on fresh / incognito sessions.
        setUser(res.data.user);
        window.history.replaceState({}, "", "/");
        await checkAuth();
        navigate("/", { replace: true });
      } catch (e) {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser, checkAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
      <div className="text-sm text-slate-500" data-testid="auth-callback-loading">Completing sign-in…</div>
    </div>
  );
}
